// extracted by mini-css-extract-plugin
module.exports = {"link":"link-module--link--3osOX","linkSingle":"link-module--linkSingle--39vnY","linkList":"link-module--linkList--bXtaq"};